<template>
  <div>
    <section style="margin-left: 20px; margin-top: 10px">
      <div class="box box-solid">
        <div class="box-body">
          <form role="form">
            <div class="form-group">
              <label class="control-label text-primary text-md"
                >Select Librarian</label
              >
              <br />
              <div class="box box-solid">
                <ul
                  class="list-group mr-4"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <!-- Loop through users and display them -->
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                    style="cursor: pointer"
                    v-for="(user, index) in users"
                    :key="index"
                    :style="{
                      backgroundColor: user.isSelected
                        ? 'lightblue'
                        : 'transparent',
                    }"
                    @click="selectUser(index)"
                  >
                    <div>
                      <span class="font-weight-bold">{{ user.name }}</span>
                      <br />
                      <span>{{ user.email }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import "bootstrap";

export default {
  data() {
    return {
      config: {
        startDate: "",
        schedulePeriod: "",
        // institutionName: "",
        partnerType: "",
        partyType: "organization",
        selectedParty: "",
        selectedPartyName: "",
        ipRange: "",
        email: "",
      },
      filteredNames: [], // namesFiltered Add this line to define the filteredNames property,
      hasError: false,
      users: [],
      showInstitutions: false,
      institutions: [],
      currUserIdx: null,
    };
  },
  components: {},
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("admin", ["currUser", "allOrgs"]),
    ...mapGetters("users", ["librarians"]),
  },
  created() {
    if (this.loggedInUser) {
      this.config.email = this.loggedInUser.username;
    }
  },
  mounted() {
    // console.log("mounted AssociateOrgsConfig");
    this.$store.dispatch("users/getLibrarians");
  },

  watch: {
    loggedInUser(newVal, oldVal) {
      // console.log("loggedInUser", newVal);
    },
    users(newVal, oldVal) {
      // console.log("users", newVal);
    },
    currUser(newVal, oldVal) {
      // console.log("currUser", newVal);
      if (newVal != null) {
        this.onCurrUserChange();
      }
    },
    allOrgs(newVal, oldVal) {
      // console.log("allOrgs", newVal);
      if (newVal != null) {
        // this.onAllOrgsChange();
      }
    },
    librarians(newVal, oldVal) {
      // console.log("librarians", newVal);
      if (newVal != null) {
        this.updateLibrarians();
      }
    },
  },
  methods: {
    selectUser(index) {
      // Reset isSelected for all users
      this.users.forEach((user) => (user.isSelected = false));
      // Set isSelected to true for the selected user
      this.users[index].isSelected = true;
      this.$store.dispatch("admin/setCurrUser", this.users[index]);
      this.currUserIdx = index;
    },
    onCurrUserChange() {
      // console.log("onCurrUserChange", this.currUser);
      let filteredOrgs = this.allOrgs;
      let assocPartyIds = this.currUser.associatedPartyIds;
      if (assocPartyIds != null) {
        assocPartyIds = assocPartyIds.split(",");
        filteredOrgs = filteredOrgs.filter(
          (org) => !assocPartyIds.includes(org.partyId)
        );
      }
      this.institutions = filteredOrgs.map((org) => {
        return {
          id: org.partyId,
          name: org.name,
          isAdded: false,
          isSelected: false,
        };
      });

      this.showInstitutions = true;
    },
    updateLibrarians() {
      // console.log("updateLibrarians ", this.librarians.length);
      this.users = this.librarians.map((user) => {
        return {
          name: user.firstName + " " + user.lastName,
          username: user.username,
          email: user.email,
          associatedPartyIds: user.associatedPartyIds,
          isSelected: false,
        };
      });
      if (this.currUserIdx != null) {
        this.selectUser(this.currUserIdx);
      }
    },
  },
};
</script>

<style scoped>
.error-message {
  border: 1px dashed red; /* Add the desired border style and color */
  text-align: center; /* Center the text horizontally */
  padding: 10px; /* Add padding for spacing */
  margin-top: 10px; /* Add margin for spacing */
  color: red;
  margin-bottom: 10px;
}
.form-control {
  background-color: #fff !important;
}

.text-xl {
  font-size: 20px;
  font-weight: bold;
}

.text-lg {
  font-size: 16px;
  font-weight: bold;
}
.text-md {
  font-size: 14px;
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/users/ApproveIpRangesConfig.vue